import type { WorkspacePulseSnapshot } from '../services/aiAgentBridge'

export type PulseReportKind =
  | 'SNAPSHOT'
  | 'RISK'
  | 'BUDGET'
  | 'DIGEST'
  | 'GOVERNANCE'

export type PulseReportStatus = 'PENDING' | 'READY' | 'FAILED' | 'ARCHIVED'

export type PulseReportSectionKind =
  | 'RISK'
  | 'BUDGET'
  | 'DIGEST'
  | 'ACTIVITY'
  | 'NARRATIVE'

export type PulseReport = {
  id: string
  workspaceId: string
  createdBy: string
  kind: PulseReportKind
  status: PulseReportStatus
  createdAtMs: number
  updatedAtMs?: number
  creditsCharged: number
  pinned?: boolean
  expiresAtMs?: number | null
  cached?: boolean
  inputs: {
    windowMs?: number
    pulseFingerprint?: string
    riskScoreAtRun?: number
    healthStateAtRun?: WorkspacePulseSnapshot['healthState']
  }
  content: {
    headline: string
    narrativeMarkdown: string
    metrics: WorkspacePulseSnapshot
    sections: Array<{
      id: string
      title: string
      body: string
      kind: PulseReportSectionKind
    }>
  }
  error?: string
}

export const PULSE_REPORT_KIND_LABEL: Record<PulseReportKind, string> = {
  SNAPSHOT: 'Snapshot',
  RISK: 'Risk',
  BUDGET: 'Budget',
  DIGEST: 'Digest',
  GOVERNANCE: 'Governance',
}

export const PULSE_REPORT_KIND_COST: Record<PulseReportKind, number> = {
  SNAPSHOT: 15,
  RISK: 3,
  BUDGET: 4,
  DIGEST: 4,
  GOVERNANCE: 10,
}

export const PULSE_REPORT_RETENTION_MS = 90 * 24 * 60 * 60 * 1000
